module.exports = __webpack_public_path__ + "static/media/CostSaving.701dfbee.svg";